import { ChevronRight, Star } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { ProductCategoriesShortcut } from '../../../../../productCategories/productCategoriesShortcut/ProductCategoriesShortcut';
import {
  LightText,
  RegularText,
  SemiBoldText,
} from '../../../../../../utils/typography/BaseText';
import { useQuery } from '@tanstack/react-query';
import { fetchPropertyById } from '../../../../../../api/propertiesAPI';

export const StaySmallSmallSinglePropertyPage = () => {
  const { id, name } = useParams();
  // const property = {};

  const category = 'Real-Estate';
  const subcategory = 'Shortlet';
  const navigate = useNavigate();

  const { data: property } = useQuery({
    queryKey: ['property', id],
    queryFn: () => fetchPropertyById(id),
  });
  return (
    <>
      <div className="lg:px-14">
        <ProductCategoriesShortcut />
      </div>
      <main className="px-5 lg:px-20">
        <div className="font-duplet flex space-x-1 items-center mt-2 mb-4">
          <RegularText
            fontSize="text-sm"
            color="cursor-pointer"
            onClick={() => navigate('/')}
          >
            SmallSmall
          </RegularText>
          <ChevronRight size={11} className="text-[#6B6B6B]" />
          <RegularText
            color="text-[#6B6B6B] text-sm cursor-pointer"
            onClick={() => navigate(-1)}
          >
            {category
              ?.replace(/-/g, ' ')
              ?.replace(/\b\w/g, (char) => char.toUpperCase())}
          </RegularText>
          <ChevronRight size={11} className="text-[#6B6B6B]" />
          <RegularText color="text-[#6B6B6B] text-sm">
            {subcategory
              ?.replace(/-/g, ' ')
              ?.replace(/\b\w/g, (char) => char.toUpperCase())}
          </RegularText>

          <ChevronRight size={11} className="text-[#6B6B6B]" />
          <RegularText color="text-[#6B6B6B] text-sm">
            {name?.charAt(0).toUpperCase() + name?.slice(1)?.replace(/-/g, ' ')}
          </RegularText>
        </div>
        <div className="flex justify-between items-end">
          <SemiBoldText fontSize="text-2xl">
            {property?.propertyTitle || 'Cool 2 Bedroom penthouse'}
          </SemiBoldText>
          <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-1">
              <Star fill="black" size="14px" />
              <RegularText>{property?.rating || 4.5}</RegularText>
              <span>({property?.reviews?.length || 0})</span>
            </div>
            <hr />
            <RegularText>Jide Alakija street, Ikate, Lekki Phase 1</RegularText>
          </div>
        </div>
      </main>
    </>
  );
};
